const resource = '/v1/memos';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  },
  store(payload) {
    return $axios.post(`${resource}`, payload);
  },
  update({id, content}) {
    return $axios.put(`${resource}/${id}`, {content});
  },
  deleteMultiple(ids) {
    return $axios.post(`${resource}/delete-multiple`, {ids});
  },
});
